var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReportingNavigationDownIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86686 0.833252L1.43352 0.833252C1.17731 0.833252 0.946444 0.987532 0.848404 1.22423C0.750363 1.46084 0.804493 1.73326 0.985626 1.9144L6.0523 6.98107C6.17111 7.09988 6.33223 7.16659 6.50019 7.16659C6.66815 7.16659 6.82927 7.09988 6.948 6.98107L12.0147 1.9144C12.1958 1.73326 12.25 1.46084 12.152 1.22423C12.0539 0.987532 11.823 0.833252 11.5668 0.833252L7.13352 0.833252L5.86686 0.833252Z",
    fill: "#2E2BEB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReportingNavigationDownIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ReportingNavigationDownIcon.1a498bfd.svg";
export { ForwardRef as ReactComponent };